import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { FALLBACK_MEMBERSHIPS, money } from "../data/site";
import { getMemberships } from "../services/veysoApi";
import { useApiData } from "../hooks/useApiData";
import FallbackNotice from "../components/FallbackNotice";
import { Card, Cards, HeroPanel, Section, heroButtonSx } from "../components/ui";
import { palette5, tokens } from "../theme";

export default function Membership() {
  const { data, usingFallback } = useApiData(getMemberships, FALLBACK_MEMBERSHIPS);
  return (
    <>
      <HeroPanel theme="gold" eyebrow="VEYSO Membership" title="More from your results. More from VEYSO."
        subtitle="Two levels, both with member pricing, personal recommendations and a home for all your results. Sample pricing." minHeight={440} />
      <Section tone="white">
        <FallbackNotice show={usingFallback} />
        <Cards min={320}>
          {(data || []).map((m, i) => (
            <Card key={m.slug} sx={{ p: 0, overflow: "hidden", display: "flex", flexDirection: "column", borderColor: i ? palette5.navy[0] : tokens.line }}>
              <Box sx={{ background: i ? palette5.navy[0] : tokens.forestDark, color: "#fff", p: 3 }}>
                <Typography variant="h4" sx={{ fontSize: 26 }}>{m.name}</Typography>
                <Typography sx={{ opacity: 0.85, mt: 0.5, fontSize: 14.5 }}>{m.tagline}</Typography>
                <Typography sx={{ fontSize: 36, fontWeight: 300, mt: 2 }}>{money(m.yearlyCents)}<Typography component="span" sx={{ fontSize: 15, opacity: 0.8 }}> / year (sample)</Typography></Typography>
              </Box>
              <Box sx={{ p: 3, flex: 1 }}>
                {m.perks.map((p) => (
                  <Box key={p} sx={{ display: "flex", gap: 1.25, py: 0.7 }}><CheckIcon sx={{ fontSize: 20, color: palette5.moss[0], mt: 0.2 }} /><Typography sx={{ fontSize: 15.5 }}>{p}</Typography></Box>
                ))}
              </Box>
              <Box sx={{ p: 3, pt: 0 }}>
                <Button fullWidth variant="contained" component={RouterLink} to="/signup" sx={heroButtonSx("gold")}>View {m.name}</Button>
              </Box>
            </Card>
          ))}
        </Cards>
        <Typography sx={{ mt: 3, color: tokens.muted, fontSize: 14 }}>Payments are not connected in this preview.</Typography>
      </Section>
    </>
  );
}
